module.exports = __webpack_public_path__ + "static/media/favourite.b40bd703.svg";